import type {
  PaymentCreate,
  PaymentManagementPublic,
  PaymentPublic,
} from '../type/payment';
import type { LifeStatus } from '../type/user';
import type { Payment } from '@/types';
import { getMonthYearFromDate, PLAN_MONTHS, type PaymentMemberRow } from '@/lib/payments';

export const PaymentAPIResponseMapper = (payment: PaymentPublic): Payment => {
  const { month, year } = getMonthYearFromDate(payment.payment_date);

  return {
    id: String(payment.id),
    memberId: String(payment.user_id),
    amount: payment.amount,
    paymentType: payment.payment_type,
    paymentDate: payment.payment_date,
    month,
    year,
    paymentNumber: payment.payment_number,
    duePeriod: payment.due_period ?? undefined,
    dueStart: payment.due_start ?? undefined,
    dueEnd: payment.due_end ?? undefined,
  };
};

export const PaymentAPIRequestMapper = (input: {
  memberId: string;
  amount: number;
  paymentType: Payment['paymentType'];
  paymentDate?: string;
  duePeriod: number;
  dueStart: string;
  dueEnd: string;
}): PaymentCreate => {
  return {
    user_id: Number(input.memberId),
    amount: input.amount,
    payment_type: input.paymentType,
    payment_date: input.paymentDate || new Date().toISOString().split('T')[0],
    due_period: input.duePeriod,
    due_start: input.dueStart,
    due_end: input.dueEnd,
  };
};

export const PaymentManagementAPIResponseMapper = (item: PaymentManagementPublic): PaymentMemberRow => {
  const totalMonths = item.total_months ?? PLAN_MONTHS;
  const monthsRemaining = Math.max(0, totalMonths - item.paid_months);

  return {
    member: {
      id: String(item.user_id),
      name: item.user_name ?? '',
      phone: item.user_phone ?? '',
      photo: item.user_profile || undefined,
      joinedDate: '',
      endDate: '',
      lifeStatus: (item.life_status?.toLowerCase() as LifeStatus) || 'alive',
    },
    summary: {
      totalPaid: item.total_paid,
      amountDue: item.due_this_today,
      monthsPaid: item.paid_months,
      monthsRemaining,
      paymentProgress: Math.min(totalMonths, item.paid_months),
    },
    isPaidThisMonth: item.this_month.toLowerCase() === 'paid',
    lastPaymentDate: item.last_payment_date ?? null,
    lastPaymentType: null,
  };
};
